const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const LOGO_SELECTOR = '[data-brite-logo]';
const COLOR_CYCLE_DURATION = 2000;
const LOAD_ANIMATION_DURATION = 800;
const HOVER_TRANSITION = 200;
const WHITE_MAX_DURATION = 100;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const applySource = (img, src) => {
  if (!img || !src) return;
  img.dataset.activeSrc = src;
  img.src = src;
  img.srcset = src;
};

const setImageSource = (img, src) => {
  if (!img || !src || img.dataset.activeSrc === src) return Promise.resolve();

  if (prefersReducedMotion.matches) {
    applySource(img, src);
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    img.style.transition = `opacity ${HOVER_TRANSITION}ms ease`;
    img.style.opacity = '0.15';

    window.setTimeout(() => {
      applySource(img, src);
      img.style.opacity = '1';
      window.setTimeout(resolve, HOVER_TRANSITION);
    }, HOVER_TRANSITION);
  });
};

const parseVariantData = (node) => {
  if (!node.dataset.briteLogoVariants) return [];

  try {
    const parsed = JSON.parse(node.dataset.briteLogoVariants);
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (error) {
    console.warn('[BRITE] Failed to parse logo variants', error);
    return [];
  }
};

const isWhiteVariant = (src) => /white/i.test(src || '');

function initBriteLogo() {
  const logoNode = document.querySelector(LOGO_SELECTOR);

  if (!logoNode) return;

  const logoImage = logoNode.querySelector('.header-logo__image-container--original img') || logoNode.querySelector('img');

  if (!(logoImage instanceof HTMLImageElement)) return;

  const variantSourcesRaw = parseVariantData(logoNode).filter(Boolean);
  const sanitizedVariants = variantSourcesRaw.filter((src) => !isWhiteVariant(src));
  const navySrc =
    sanitizedVariants.find((src) => src.includes('Brite_Blue')) ||
    sanitizedVariants[0] ||
    variantSourcesRaw.find((src) => !isWhiteVariant(src)) ||
    logoImage.currentSrc ||
    logoImage.src;
  const baseSrc = navySrc || logoImage.currentSrc || logoImage.src;
  logoImage.dataset.activeSrc = baseSrc;

  const variantSources = sanitizedVariants.filter((src) => src !== baseSrc);
  const accentSrc = variantSources.find((src) => src.includes('Brite_Pink') || src.includes('Brite_Yellow')) || variantSources[0] || baseSrc;
  let isCycling = Boolean(variantSources.length);
  let hoverState = false;

  const startDrift = () => {
    if (prefersReducedMotion.matches) return;
    logoNode.classList.add('brite-logo--drift');
  };

  if (!prefersReducedMotion.matches) {
    logoNode.classList.add('brite-logo--enter');
    window.setTimeout(() => {
      logoNode.classList.remove('brite-logo--enter');
      startDrift();
    }, LOAD_ANIMATION_DURATION + 100);
  }

  const runColorCycle = async () => {
    if (!variantSources.length) {
      isCycling = false;
      return;
    }

    const cycleSequence = [...variantSources, baseSrc];
    const step = Math.max(COLOR_CYCLE_DURATION / cycleSequence.length, 160);

    for (const variant of cycleSequence) {
      await setImageSource(logoImage, variant);
      const hold = isWhiteVariant(variant) ? Math.min(WHITE_MAX_DURATION, step) : step;
      await delay(hold);
    }

    await setImageSource(logoImage, baseSrc);
    isCycling = false;
  };

  runColorCycle();

  const handleHoverToggle = (active) => {
    if (isCycling || hoverState === active) return;
    hoverState = active;

    if (active) {
      setImageSource(logoImage, accentSrc);
    } else {
      setImageSource(logoImage, baseSrc);
    }
  };

  logoNode.addEventListener('mouseenter', () => handleHoverToggle(true));
  logoNode.addEventListener('mouseleave', () => handleHoverToggle(false));
}

document.addEventListener('DOMContentLoaded', initBriteLogo);
